"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUsingNode = void 0;
function isUsingNode() {
    return typeof process !== 'undefined' && process.release && process.release.name === 'node';
}
exports.isUsingNode = isUsingNode;
//# sourceMappingURL=environment.js.map